import { Controller } from '@hotwired/stimulus';

// Shows a grayed-out placeholder calendar in the section's downstream container while the server
// recomputes availability after the selection changes; the autosave Turbo Stream response then swaps
// in the real calendar. The markup lives in an inert <template> (see _shooting_section).
export default class extends Controller {
  static targets = ['template'];
  static values = { container: String, presetStudio: String };

  show() {
    if (!this.hasTemplateTarget) return;
    if (!this.categoryInForce()) return;
    if (!this.studioResolvable()) return;

    const container = document.getElementById(this.containerValue);
    if (!container) return;

    container.replaceChildren(this.templateTarget.content.cloneNode(true));
  }

  // A picked dropdown value on the shooting / discount paths, or fixed by the code on the access-code
  // path, which has no category select at all.
  categoryInForce() {
    const category = this.element.querySelector('select[name="form[category]"]');
    return !category || category.value !== '';
  }

  // Whether the server will be able to resolve a studio for this selection — that is what the calendar
  // is priced and offered against. Off studio, the address resolves to the nearest servicing studio,
  // so the calendar loads as soon as the address is complete enough to geocode.
  studioResolvable() {
    if (this.offStudio()) return this.addressComplete();

    const field = this.locationField();
    const studio = field ? field.value : '';
    // A studio deep-link's preset resolves server-side on this very change, so the dropdown still
    // reads empty here.
    return studio !== '' || this.presetStudioValue !== '';
  }

  // The merged location dropdown, shared by every path.
  locationField() {
    return this.element.querySelector('select[name="form[location]"]');
  }

  // Off-studio is a value of the merged dropdown.
  offStudio() {
    const field = this.locationField();
    return Boolean(field && field.value === 'off_studio');
  }

  // Mirrors the server-side guard: geocoding is skipped unless all three parts are present.
  addressComplete() {
    return ['street', 'postal_code', 'city'].every((field) => {
      const input = this.element.querySelector(`[name="form[${field}]"]`);
      return Boolean(input && input.value.trim() !== '');
    });
  }
}
